import { DOMAIN as _ } from 'configs/constants/system'

/****************
 * Action calls *
 ****************/

export const HANDLE_ADD_HISTORY_ENTRY = `${_} HANDLE_ADD_HISTORY_ENTRY`
export const HANDLE_REMOVE_LAST_HISTORY_ENTRY = `${_} HANDLE_REMOVE_LAST_HISTORY_ENTRY`
export const HANDLE_CLEAR_HISTORY = `${_} HANDLE_CLEAR_HISTORY`
